const kanban = () => ({
    parentNav: 'kanban',
    routes: ['kanban_index'],
    menuItems: [],
  });
  
  export default kanban;